import { useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { notifPrefs } from 'helpers/notifications';

const NotificationSettings = () => {
  const [sound, setSound] = useState(notifPrefs.sound());
  const [desktop, setDesktop] = useState(notifPrefs.desktop());
  const [note, setNote] = useState<string | null>(null);

  const toggleSound = (v: boolean) => {
    setSound(v);
    notifPrefs.setSound(v);
  };

  const toggleDesktop = async (v: boolean) => {
    if (v && typeof Notification !== 'undefined' && Notification.permission !== 'granted') {
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') {
        setNote('Desktop notifications are blocked in your browser settings.');
        setDesktop(false);
        notifPrefs.setDesktop(false);
        return;
      }
    }
    setNote(null);
    setDesktop(v);
    notifPrefs.setDesktop(v);
  };

  return (
    <>
      <h2 className="mb-1 text-body-emphasis">Notifications</h2>
      <p className="text-body-tertiary mb-4">
        These preferences apply to this device only.
      </p>

      <Card style={{ maxWidth: 560 }}>
        <Card.Body className="d-flex flex-column gap-3">
          <Form.Check
            type="switch"
            label="Play a sound for new messages and visitors"
            checked={sound}
            onChange={e => toggleSound(e.target.checked)}
          />
          <Form.Check
            type="switch"
            label="Show desktop notifications when the tab is in the background"
            checked={desktop}
            onChange={e => toggleDesktop(e.target.checked)}
          />
          {note && <div className="fs-9 text-danger">{note}</div>}
        </Card.Body>
      </Card>
    </>
  );
};

export default NotificationSettings;
